import { render, staticRenderFns } from "./exchangeRateInfoDetail.vue?vue&type=template&id=637aab3d&scoped=true"
import script from "./exchangeRateInfoDetail.vue?vue&type=script&lang=js"
export * from "./exchangeRateInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./exchangeRateInfoDetail.vue?vue&type=style&index=0&id=637aab3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637aab3d",
  null
  
)

export default component.exports